export default __webpack_public_path__ + "static/media/rtg-2.6d517a87.svg";